export const userSignin = (user) => {
    return (dispatch) => dispatch({ type: 'SIGNIN', user: user });
};

export const userSignout = () => {
    return (dispatch) => dispatch({ type: 'SIGNOUT', user: null });
};
